/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUserCardProvider } from '../../../../utilities/sharedHooks/user';
import {
  CardContainer,
  FlipButton,
  CardHolderDisplayName,
  CVVLabel,
  BlackRow,
  EXPLabel,
  ValidUntilDate,
  CVVValue,
  IBAN,
  TopText,
  MasterLogo,
  WaterMark,
  BottomText,
} from './partials';
import { cardProviders } from '../../../../screens/Card/constants';
import MonavateCardBack from '../MonavateCardBack';

const Slot = ({ children }) => children;
export const VirtualCardBack = ({
  details = null,
  isShowSecretInfo = false,
  securityNumbersForm,
  ...props
}) => {
  const { cardProvider } = useUserCardProvider();

  const visibleOnMasterCard = useMemo(
    () => cardProvider === cardProviders.MONAVATE,
    [cardProvider]
  );

  const handleOnClickFlip = () => {
    props.flip();
    props.showSecretInfo();
  };

  if (visibleOnMasterCard) {
    return (
      <MonavateCardBack
        details={details}
        isShowSecretInfo={isShowSecretInfo}
        securityNumbersForm={securityNumbersForm}
        flip={props.flip}
        toggleCvvModal={props.toggleCvvModal}
        showSecretInfo={props.showSecretInfo}
      />
    );
  }

  return (
    <CardContainer>
      <MasterLogo isVisible={visibleOnMasterCard} />
      <BlackRow />
      <WaterMark isVisible={visibleOnMasterCard} />
      <IBAN
        isShowSecretInfo={isShowSecretInfo}
        isLoadingPAN={securityNumbersForm?.isLoadingPAN}
        cardProvider={cardProvider}
        cardNumberObscured={details?.cardNumberObscured}
        pan={securityNumbersForm?.pan}
        onClick={props.toggleCvvModal}
        panError={securityNumbersForm?.panError}
      />
      <EXPLabel cardProvider={cardProvider} />
      <ValidUntilDate cardValidThrough={details?.cardValidThrough} />
      <CVVLabel cardProvider={cardProvider} />
      <CVVValue
        isShowSecretInfo={isShowSecretInfo}
        isLoadingCVC={securityNumbersForm?.isLoadingCVC}
        cvc={securityNumbersForm?.cvc}
        onClick={props.toggleCvvModal}
        cvcError={securityNumbersForm?.cvcError}
      />
      <CardHolderDisplayName displayName={details?.cardDisplayName} />
      <BottomText cardProvider={cardProvider} />
      <TopText isVisible={visibleOnMasterCard} />
      <Slot dsc="third">
        <FlipButton onClick={handleOnClickFlip} />
      </Slot>
    </CardContainer>
  );
};

export default VirtualCardBack;

VirtualCardBack.propTypes = {
  details: PropTypes.object,
  flip: PropTypes.func.isRequired,
  toggleCvvModal: PropTypes.func.isRequired,
  isShowSecretInfo: PropTypes.bool,
  showSecretInfo: PropTypes.func.isRequired,
  securityNumbersForm: PropTypes.object.isRequired,
};
